import { engineComponent } from "neo-common";
import { Style } from "./Style";
import { ComponentTypes } from "../../ComponentTypes";

@engineComponent(ComponentTypes.Style)
export class ProtonStyle extends Style {
    node: Element;

    constructor() {
        super();
    }

    create(node: Element) {
        super.create(node);

        this.node = node;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Styles/ProtonStyle.ts
 **/